
import React from 'react';
import { UniversalPlan } from "@/components/plans";
import { FAQSection } from "@/components/common/FAQ";

const PricingPage = () => {
  // Simple mock props for UniversalPlan component in public page context
  const mockProps = {
    hasActiveSubscription: false,
    onSubscribe: () => window.location.href = "/signup",
    isCheckoutLoading: false
  };

  const pricingFaqs = [
    {
      question: "What's included in the subscription?",
      answer: "Access to all AI Staff members, including Marketing, Sales, Customer Support, and more as they become available."
    },
    {
      question: "Can I cancel my subscription?",
      answer: "Yes, you can cancel your subscription at any time. There are no long-term commitments."
    },
    {
      question: "How many AI Staff can I add?",
      answer: "With the Universal Subscription, you can add unlimited AI Staff to your business."
    }
  ];

  return (
    <div className="container mx-auto py-12 px-4">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Simple, Transparent Pricing</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Get unlimited access to AI Staff with our straightforward subscription plan.
        </p>
      </div>

      <div className="max-w-lg mx-auto">
        <UniversalPlan {...mockProps} />
      </div>
      
      <div className="mt-24">
        <FAQSection
          title="Frequently Asked Questions"
          faqs={pricingFaqs}
          className="text-left"
        />
      </div>
    </div>
  );
};

export default PricingPage;
